// extracted by mini-css-extract-plugin
export default {"productDescription":"v--z","featuredDescription":"w--z","description":"x--z","more":"y--z","descriptionSku":"z--z"};